export const PromoProduct = (productData, title) => ({
  product: null,
  variant: null,
  flavor: "Moroccan Chocolate",
  purchaseType: "monthly",
  loading: true,

  async init() {
    const flavor = this.getFlavorFromUrl();
    this.flavor = flavor || (title || "Moroccan Chocolate").split(" / ")[0];

    await this.setProduct(productData?.handle);

    this.setVariant();

    this.loading = false;

    this.$watch("flavor", () => {
      this.setVariant();
    });

    this.$watch("purchaseType", () => {
      this.setVariant();
    });
  },

  getFlavorFromUrl() {
    const url = new URL(window.location.href);

    return url.searchParams.get('flavor');
  },

  async setProduct(handle) {
    if (!handle) {
      return;
    }

    try {
      this.product = await fetch(`/products/${handle}.js`).then((res) => res.json());
    } catch (error) {
      console.error(error);
    }
  },

  setVariant() {
    const { variants } = this.product;
    if (!variants?.length) {
      return;
    }

    const { flavor } = this;

    if (!flavor) {
      this.variant = variants[0];
      return;
    }

    this.variant = variants.find((item) => {
      return [flavor].every((option) => item.title.split(" / ").includes(option));
    });

    if (this.variant) {
      return;
    }

    this.variant = this.variant.find((item) => {
      return item.title.includes(flavor);
    });

    if (this.variant) {
      return;
    }

    this.variant = variants[0];
  },

  async handleATC() {
    if (this.loading) {
      return;
    }

    const { variant } = this;
    if (!variant?.available) {
      return;
    }

    const data = {
      items: [
        {
          id: variant.id,
          quantity: 1,
          selling_plan:
            (this.purchaseType === "monthly" && variant.selling_plan_allocations[0]?.selling_plan_id) || null,
        },
      ],
    };

    const { addonVariantIdInput } = this.$refs;
    if (addonVariantIdInput?.checked) {
      const addonVariantId = parseInt(addonVariantIdInput.value || "0");
      if (addonVariantId) {
        data.items.push({
          id: addonVariantId,
          quantity: 1,
        });
      }
    }

    try {
      this.loading = true;

      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      this.loading = false;
    } catch (error) {
      console.error(error);
    }
  }
});
